<mat-card class="row  box-shadow ">
  <mat-card-header class=" row col-12">
    <mat-card-title class="col-12">
      <h3>Mes dernières réservations</h3>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="col-12">
      <ng-template [ngIf]="bookList != null">
        <ng-template [ngIf]="bookList?.length > 0 " [ngIfElse]="empty">
          <table class="col-12 last-station">
            <tr class="row justify-content-around" *ngFor="let book of bookList | slice:0:5">
              <td class="col-1">
                <mat-icon svgIcon="autopartage"></mat-icon>
              </td>
              <td class="col-sm-5 col-11">
                <label>
                  {{book.station_name}}
                </label>
              </td>
              <td class="col-sm-1 col-12">
                <label>
                  {{book.price}} €
                </label>
              </td>
              <td class="col-sm-5 col-12">
                <div class="row justify-content-around">
                  <a class="col-sm-6 col-8" routerLink="/auth/reservation/{{book.id}}">
                    <button class="full-width" mat-stroked-button color="primary"><label>Détail</label></button></a>
                  <a class="col-sm-6 col-8" routerLink="/auth/reservation/{{book.id}}">
                    <button class="full-width" mat-stroked-button color="primary"><label>Réserver à nouveau</label></button>
                  </a>
                </div>
              </td>
            </tr>
          </table>
        </ng-template>
        <ng-template #empty>
          <h4>Aucune station trouvée</h4>
        </ng-template>
      </ng-template>
    </div>
  </mat-card-content>
  <ng-template [ngIf]="bookList != null">
    <ng-template [ngIf]="bookList?.length > 0 ">
      <mat-card-actions>
        <div class="col-12">
          <div class="row justify-content-center">
            <a class="col-sm-3 col-8" routerLink="/auth/reservations">
              <button class="full-width" mat-stroked-button color="primary"><label>
                  Voir mes réservations
                </label>
              </button>
            </a>
          </div>
        </div>
      </mat-card-actions>
    </ng-template>
  </ng-template>
  <div class="row loading-block">
    <ng-template [ngIf]="bookList == null">
      <mat-progress-bar class="col-12" mode="indeterminate" color='primary'></mat-progress-bar>
    </ng-template>
  </div>
</mat-card>
